module.exports = __webpack_public_path__ + "img/business-1.c10357a1.png";